<template>
  <el-checkbox-group 
    class="ticket_form_checkbox"
    v-model="modelValue"
    @change="onChange">
    <el-checkbox v-for="e in item.enums"
      :key="e.id"
      :label="e.id">{{e.name}}</el-checkbox>
  </el-checkbox-group>
</template>

<style>
.ticket_form_checkbox .el-checkbox__label {
  word-break: break-all;
  white-space: pre-wrap!important;
}
</style>

<script>
export default {
    name : 'TicketFormCheckbox',

    props : ['value', 'item'],

    data() {
      return {
        modelValue : []
      }
    },

    watch : {
      value() {
        console.log('#24 TicketFormCheckbox watch', this.value, this.modelValue);

        this.modelValue = this.value ? this._toArray(this.value) : [];
      }
    },

    mounted() {
      console.log('#30 TicketFormCheckbox mounted', this.value, this.modelValue); // 详情页 mounted 传入空

      this.modelValue = this.value ? this._toArray(this.value) : [];
    },

    methods : {
      onChange() {
        this.$emit('input', this.modelValue);

        this.$emit('change', this.modelValue);
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormCheckbox.vue